import { defineComponent as _defineComponent } from 'vue'
import { createVNode as _createVNode, openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue"

const _hoisted_1 = { class: "date-rule" }

import { computed } from "vue";
import MDateTimePicker from "@/BasicComponentLibrary/MDateAndTimePicker.vue";


export default /*#__PURE__*/_defineComponent({
  __name: 'DateTimeRule',
  props: {
    value: {}
  },
  emits: ["input"],
  setup(__props: any, { emit: emits }) {

const props = __props;




const localModal = computed({
  get: () => {
    return props.value;
  },
  set: (nv) => {
    emits("input", nv);
  }
});

return (_ctx: any,_cache: any) => {
  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _createVNode(MDateTimePicker, {
      modelValue: localModal.value,
      "onUpdate:modelValue": _cache[0] || (_cache[0] = ($event: any) => ((localModal).value = $event))
    }, null, 8, ["modelValue"])
  ]))
}
}

})